import { type CSSProperties, useContext } from "react";
import { OnboardingLayoutContext } from "..";
import tessImage from "assets/images/tess.jpg";
import profileLogoImage from "assets/images/logo/profile.svg?url";
import { Container, Content, Logo, Avatar } from "./styles";

export interface HeaderProps {
  avatar: "person" | "faye" | null;
  topOffset: string;
}
export function Header({ avatar, topOffset }: HeaderProps) {
  const { headerRef } = useContext(OnboardingLayoutContext);

  const avatarImage =
    avatar === "person"
      ? tessImage
      : avatar === "faye"
        ? profileLogoImage
        : null;

  return (
    <Container
      ref={headerRef}
      style={{ "--top-offset": topOffset } as CSSProperties}
    >
      <Content>
        <Logo />
        {avatarImage && <Avatar alt="" src={avatarImage} />}
      </Content>
    </Container>
  );
}
